import { render, staticRenderFns } from "./PromotionBundles.vue?vue&type=template&id=13c2c909&"
import script from "./PromotionBundles.vue?vue&type=script&lang=js&"
export * from "./PromotionBundles.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports